/*
 * fn: scrollToTop
 *
 * Scroll the window to the top of the page
 *
 */
export const scrollToTop = () => window.scrollTo(0, 0)
